import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let Radio = class Radio extends Vue {
    render(h) {
        return h('a-radio-group', { props: {
                disabled: true,
                options: this.control.options.options ? this.control.options.options.split(';') : []
            } });
    }
};
tslib_1.__decorate([
    Prop()
], Radio.prototype, "control", void 0);
Radio = tslib_1.__decorate([
    Component({ name: 'Radio' })
], Radio);
export default Radio;
